/* eslint-disable react/prop-types */
import './ModulePage.scss';
import * as React from 'react';
import Module from '../../../components/Module/Module';
import { CBAccordion} from '../../../constants/apricotCBform';
import { ToolTip } from '../../../components';
import {lockMsg, lockMsgAdmin} from '../../../constants/messages';
import { ADMIN_ROLE } from './exportfiles';

//accordion in module page
const Accordion = ({isLocked, org_rol_s,status,org_id, cat_id, 
  sampleData, key_data, cds, setCatStatus, dispatcher, state}) => {

    React.useLayoutEffect(() => {
      CBAccordion({ elem: document.querySelector('.cb-accordion')});
    }, []);

  return (
    <div id='module_accordion' className='cb-accordion col-md-12 moduleSection' data-cb-apricot='accordion'>
      <div className="cb-accordion-controls" style={{marginBottom:'25px'}}>
        <div className="cb-accordion-title">
          <h3 className="cb-font-weight-regular">
            <div className='display-flex'>
              
              <h2 id='CategoryName'>{sampleData.CategoryName}
              &nbsp;&nbsp;
              {isLocked?
              <ToolTip tooltipid={'tip_cat_'+cat_id} tooltipMsg={org_rol_s===ADMIN_ROLE?lockMsgAdmin:lockMsg} 
                        innerMsg={''} className={'cb-icon cb-lock'} />
              :<></>
              } </h2>
            </div>
          </h3>
        </div>
        <div className="cb-accordion-buttons">
          <button type="button" className="cb-btn cb-btn-greyscale cb-accordion-expand" id='accordionExp'>Expand All</button>
          <button type="button" className="cb-btn cb-btn-greyscale cb-accordion-collapse" id='accordionCol'>Collapse All</button>
        </div>
      </div>

      <div className='cb-accordion-panels' data-testid='accordionPanel' id='moduleAccordion'>
          {sampleData.modules?.map((md, index) => {
            let mycatId = cat_id;
            let mystatus = status;
            let moduleLocked = false;
            let showModuleLock = false;

            if (key_data === true || cds == true) {
              mycatId = md.category;
              mystatus = md.categoryStatus||''; //this does not exist
              moduleLocked = md.isLocked;
              if(moduleLocked&&cds==true){
                showModuleLock = true;
              }
            }
            else{
              moduleLocked = isLocked;
            }

            return (
                <Module key={`module-${index}`} mindex={`mid-${index}`} isLocked={moduleLocked} org_rol={org_rol_s} 
                  statusOfModule={mystatus} json={{ ...md, org_id, cat_id: mycatId }} 
                  setCatStatus={setCatStatus} dispatcher={dispatcher} state={state}
                  showModuleLock={showModuleLock} curcat={cat_id}
                />
            );
          })
          }
      </div>
    </div>
  );
};

export default Accordion;